/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.0.0
 */

import produce from 'immer';

import { HIDE_LOADER, SET_TEXT_LOADER, SHOW_LOADER } from './loaderConstants';
import { IGlobalActionType } from './loaderTypes';

export interface ILoaderReducer {
    showLoader: boolean;
    textLoader: string;
}

export const initialLoaderState: ILoaderReducer = {
    showLoader: false,
    textLoader: '',
};

const loaderReducer = (state: ILoaderReducer = initialLoaderState, action: IGlobalActionType) =>
    produce(state, (draft: ILoaderReducer) => {
        switch (action.type) {
            case SHOW_LOADER:
                draft.showLoader = true;
                break;
            case HIDE_LOADER:
                draft.showLoader = false;
                draft.textLoader = '';
                break;
            case SET_TEXT_LOADER:
                draft.textLoader = action.payload;
                break;
            default:
                return state;
        }
    });

export default loaderReducer;
